import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SHOW_HIDE_PASSWORD_LANGUAGE } from './form-input.constant';

@Component({
  selector: 'app-form-element',
  templateUrl: './form-element.component.html'
})
export class FormElementComponent implements OnInit, OnDestroy {
  formElement!: FormGroup;
  inputNgModelNojs: string = '';
  submitted: boolean = false;
  isBrowser: boolean = true;
  paramsSubscription!: Subscription;
  constructor(
    private formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  showHidePasswordLabelEnglish = SHOW_HIDE_PASSWORD_LANGUAGE.english;

  ngOnInit(): void {
    this.formElement = this.formBuilder.group({
      inputNumber: ['', [Validators.required]],
      inputVal: [''],
      formId:[''],
      emailVal: ['', [Validators.required, Validators.email]],
      passwordVal: ['', Validators.required]
    });

    this.paramsSubscription = this._activatedRoute.queryParams.subscribe(param => {
      if (param['noJsInput']) {
        this.inputNgModelNojs = param['noJsInput'];
      }
    });
  }

  ngOnDestroy(): void {
    if(this.isBrowser){
      this.paramsSubscription.unsubscribe();
    }  
  }

  onSubmit() {
    this.submitted = true;
  }
}